import React, { useState, useEffect, useRef } from 'react';
import backgroundImage from '@/images/Education.webp';

interface EducationItem { year: string; degree: string; institution: string; description: string; }

const educationData: EducationItem[] = [
  { year: '2022', degree: 'B.Sc.hons Computing & Information Systems', institution: 'Sabaragamuwa University of Sri Lanka', description: 'Graduated with second class upper division' },
  { year: '2016', degree: 'G.C.E. Advanced Level', institution: 'Ruhunu Vijayaba College', description: 'Passed the G.C.E. Advanced Level Examination in the Maths stream with an  A in Mathematics, and C grades in Physics and Chemistry' },
  // { year: '2014', degree: 'Middle School', institution: 'School C', description: 'Sed do eiusmod tempor.' },
];

const Education = () => {
  const [visibleItems, setVisibleItems] = useState<number[]>([]);
  const eduRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisibleItems(educationData.map((_, i) => i));
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="education" className="relative text-white bg-cover bg-center bg-fixed" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="absolute inset-0 bg-black/30 z-0"></div>
      <div className="relative z-10 container mx-auto py-24 px-4 bg-transparent">
      <h5 className=' text-primary mb-6 font-Urbanist font-medium tracking-widest text-xl'>Education</h5>
        <h2 className="section-heading mb-8 font-light tracking-widest sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">Yep - It’s all about Learning, Growing & Glowing 🎓🌟</h2>
        <div ref={eduRef} className="relative mx-auto sm:w-1/2 w-[unset] text-center mt-12">
          {educationData.map((item, index) => (
            <div key={index} className={`relative pl-8 mb-8 transition-all duration-500 ease-out ${visibleItems.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: `${index * 150}ms` }}>
             
              <span className="text-lg tracking-widest font-light text-white">{item.year}</span>
              <h3 className="text-xxl font-medium tracking-widest">{item.degree}</h3>
              <span className="tracking-widest font-light text-white">{item.institution}</span>
              <p className="text-xl text-white mt-2 tracking-widest">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
